import React, { useEffect } from "react";
import './HomePage.css';
import { Link } from 'react-router-dom';
import ProductSlider from './Productslider.jsx';
import { getCachedData } from './cacheService'; // Import the service
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

function HomePage() {
    
    useEffect(() => {
        // 1. Warm up the cache for the whole site as soon as the user hits Home
        getCachedData().catch(err => console.error("Cache warm-up failed", err));

        // 2. Preload the Hero Background Image
        // Replace the URL below with your actual main background image path
        const heroImg = new Image();
        heroImg.src = "/assets/your-main-hero-bg.jpg"; 
    }, []);

    return (
        <>             
        <div className="Wrapper">
            <div className="Display">
                <h2>Quality Aluminium Windows & Doors</h2>
                <p>
                    Transform your home with our premium aluminium windows,
                    doors, and gates. Combining durability, elegance, 
                    and custom design for South African homes.
                </p>
                <div className="cards">
                    <div className="ActualC">
                        <h4>
                            <span className="material-symbols-outlined">shield</span>
                             5-Year Warranty
                        </h4>
                    </div>
                    <div className="ActualC">
                        <h4>
                            <span className="material-symbols-outlined">electric_bolt</span>
                            Energy Efficient
                        </h4>
                    </div>
                    <div className="ActualC">
                        <h4>
                            <span className="material-symbols-outlined">kid_star</span>
                            Custom Design
                        </h4>
                    </div>
                </div>
                <div className="Btns">
                    <div className="RptBtn">
                        <Link to="/Form" className="button-link">
                             Request Free Quote
                            <span className="material-symbols-outlined">arrow_forward</span>
                        </Link>
                    </div>
                    <div className="Viewbtn">
                        <Link to="/projects" className="button-link">
                            View Portfolio  
                            <span className="material-symbols-outlined">photo_frame</span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
        
        {/* The Slider handles its own image preloading internally */}
        <ProductSlider />
        <br />
        </>
    );
}

export default HomePage;
